import React, { useEffect, useState } from 'react'
import { Get_Setting_Api, Update_Setting_Api } from '../API/SettingApi';
import { Button, Form, Input, InputNumber, Row, Col } from 'antd';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
import { AllCategoryComponent } from '../Components/Category/AllCategoryComponent';
// ======================================================================
export const Setting = ({ setLoading, showMessage, cancelEdit, settingUpdated }) => {
    // =================================================================
    const [setting, setSetting] = useState();
    const [offCategoryId, setOffCategoryId] = useState(-1);
    const [form] = Form.useForm()
    // =================================================================
    useEffect(() => {
        loadData();
    }, []);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await Get_Setting_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setSetting(data.messageData.data);
                console.log("data.messageData.data",data.messageData.data)
                setOffCategoryId(data.messageData.data.offCategoryId);
                form.setFieldsValue(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            values.offCategoryId = offCategoryId;

            let data = await Update_Setting_Api(values);
            setLoading(false);

            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful")
                settingUpdated();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // =================================================================
    return (
        <>
            {setting ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            تنظیمات
                        </h2>
                    </div>

                    <div className='container'>
                        <Form
                            form={form}
                            name="basic"
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 19 }}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed}
                        >

                            <Form.Item
                                name="siteTitle"
                                label="عنوان سایت"
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="siteUrl"
                                label="آدرس سایت"
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="siteComment"
                                label="شرح سایت"
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="loginPageTitle"
                                label="عنوان صفحه لاگین"
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="babyAge"
                                label="حداکثر سن کودک"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="offCategoryId"
                                label="گروه خارج از سرویس"
                            >
                                <AllCategoryComponent
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    parentId={0}
                                    isShowAddSubCategory={false}
                                    isShowEdit={false}
                                    isShowDelete={false}
                                    isLoadObjectInstanceCategories={false}
                                    isLoadCategoryFromParam={true}
                                    selectedCategory={offCategoryId}
                                    isShowCheckBox={true}
                                    onCheckChange={(catId, checked) => { if (checked) setOffCategoryId(catId); }}
                                />
                                {/* <InputNumber /> */}
                            </Form.Item>

                            <Form.Item
                                name="smsProvider"
                                label="Provider پیامک"
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="smsapiKey"
                                label="کلید API پیامک"
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="smsVerifyTemplateId"
                                label="کلید پیامک وریفای لاگین"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="smsWaitingForLotteryTemplateId"
                                label="کلید پیامک ثبت نام در قرعه کشی"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="smsWaitingForValidateTemplateId"
                                label="کلید پیامک فراخوان جهت قطعی کردن"
                            >
                                <InputNumber />
                            </Form.Item>
                            
                            <Form.Item
                                name="smsFaildInLotteryTemplateId"
                                label="کلید پیامک برنده نشدن در قرعه کشی"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="smsCompletedTemplateId"
                                label="کلید پیامک قطعی شدن ثبت نام"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="relationListId"
                                label="کلید لیست نسبت ها"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="stateListId"
                                label="کلید لیست استانها"
                            >
                                <InputNumber />
                            </Form.Item>

                        </Form>
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}
